// extracted by mini-css-extract-plugin
export var input = "Checkbox-module--input--41052";